module.exports = __webpack_public_path__ + "static/media/remove-unavailability.2a34b8f5.png";